const NODE_TEXT = 3;

const matches = (element, selector) => element.matches(selector);

const children = (element, selector) => {
    const childrenElems = [].concat(...element.childrenElems);
    return childrenElems.filter(child => child.matches(selector));
};

const parents = (element, selector) => {
    const parentsElems = [];
    let ancestor = element.parentNode;
    while (ancestor && ancestor.nodeType === Node.ELEMENT_NODE && ancestor.nodeType !== NODE_TEXT) {
        if (matches(ancestor, selector)) {
            parentsElems.push(ancestor);
        }
        ancestor = ancestor.parentNode;
    }
    return parentsElems;
};

const prev = (element, selector) => {
    let previous = element.previousElementSibling;
    while (previous) {
        if (previous.matches(selector)) {
            return [previous];
        }
        previous = previous.previousElementSibling;
    }
    return [];
};

const next = (element, selector) => {
    let nextElem = element.nextElementSibling;
    while (nextElem) {
        if (matches(nextElem, selector)) {
            return [nextElem];
        }
        nextElem = nextElem.nextElementSibling;
    }
    return [];
};

const siblings = (element, selector) => [...element.parentNode.children].filter(child => child !== element && child.matches(selector));

export {
    matches,
    children,
    parents,
    prev,
    next,
    siblings,
};
